export const FETCH_USERS_INIT_ACTION = "FETCH_USERS_INIT_ACTION";
export const FETCH_USERS_SUCCESS_ACTION = "FETCH_USERS_SUCCESS_ACTION";
export const FETCH_USERS_FAIL_ACTION = "FETCH_USERS_FAIL_ACTION";

export const CREATE_USER_INIT_ACTION = "CREATE_USER_INIT_ACTION";
export const CREATE_USER_SUCCESS_ACTION = "CREATE_USER_SUCCESS_ACTION";
export const CREATE_USER_FAIL_ACTION = "CREATE_USER_FAIL_ACTION";

export const UPDATE_USER_STATUS_INIT_ACTION = "UPDATE_USER_STATUS_INIT_ACTION";
export const UPDATE_USER_STATUS_SUCCESS_ACTION = "UPDATE_USER_STATUS_SUCCESS_ACTION";
export const UPDATE_USER_STATUS_FAIL_ACTION = "UPDATE_USER_STATUS_FAIL_ACTION";

export const fetchUsersAction = (value) => ({
    type: FETCH_USERS_INIT_ACTION,
    value,
});

export const createUserAction = (value) => ({
    type: CREATE_USER_INIT_ACTION,
    value,
});

export const updateUserStatusAction = (value) => ({
    type: UPDATE_USER_STATUS_INIT_ACTION,
    value,
});
